import TimerWorker from '@/workers/timerWorker.ts?worker';
import { onBeforeUnmount, ref } from 'vue';
/**
 * 引入 Web Worker
 *
 * ?worker：在 Vite 中，使用 ?worker 後綴來導入 Web Worker 文件。這是 Vite 的特性，允許你直接在 Vue 組件中使用 Web Worker，並自動進行處理。
 * worker.postMessage()：通過 postMessage 傳遞消息給 Web Worker，控制其行為（如 start 或 stop）。
 * worker.onmessage：監聽來自 Web Worker 的消息，每次收到 'tick' 時，將 ticks 加 1。
 * onBeforeUnmount：在組件卸載時終止 Web Worker，防止資源洩露。
 */
export const useTimer = () => {
  const ticks = ref(0); // 計數變量
  let worker: Worker | null = null;

  // 開始計時
  const startTimer = (interval = 1000, triggerEvent?: () => void) => {
    if (!worker) {
      worker = new TimerWorker();

      worker.onmessage = () => {
        ticks.value += 1; // 每次 'tick' 時，計數器加一
        if (triggerEvent) {
          triggerEvent();
        }
      };
    }
    worker.postMessage({ type: 'start', interval }); // 每隔 interval 毫秒發送一次 'tick'
  };

  // 停止計時
  const stopTimer = () => {
    if (worker) {
      worker.postMessage({ type: 'stop' });
    }
  };

  const abortTimer = () => {
    if (worker) {
      stopTimer();
      worker.terminate();
      worker = null;
      ticks.value = 0
    }
  };

  // 組件卸載時終止 Worker
  onBeforeUnmount(() => {
    abortTimer();
  });

  return {
    ticks, // 返回計數變量
    startTimer, // 返回開始計時函數
    stopTimer, // 返回停止計時函數
    abortTimer  //捨棄計時函數
  };
};
